import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";

import { color, space } from "../theme/designTokens";

type InfoDialogProps = {
  title: string;
  content: string;
  onClose: () => void;
};

export const InfoDialog = ({ title, content, onClose }: InfoDialogProps) => {
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          backgroundColor: color.background,
          px: space.xs,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ m: space.xs, minHeight: "200px", whiteSpace: "pre-wrap" }}>{content}</DialogContent>
    </Dialog>
  );
};
